import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { getCookie } from "../_helpers/cookie";

function Protected({ children }) {
  const authState = useSelector((state) => state.authentication);
  const getUser = authState?.user || JSON.parse(localStorage.getItem('user_pro'));
  const authToken = getCookie("authToken") || localStorage.getItem("userToken");
  const isLoggedIn = getUser && authToken && (getUser.success || getUser.sucess || authState?.loggedIn);

  return isLoggedIn ? children : <Navigate to="/" replace />;
}

export default Protected;

export function CheckLoggedin({ children }) {
  const authState = useSelector((state) => state.authentication);
  const getUser = authState?.user || JSON.parse(localStorage.getItem('user_pro'));
  const authToken = getCookie("authToken") || localStorage.getItem("userToken");
  const isLoggedIn = getUser && authToken && (getUser.success || getUser.sucess || authState?.loggedIn);
  
  return isLoggedIn ? <Navigate to="/dashboard" replace /> : children;
}